import React from 'react';
import { styled } from '@mui/material/styles';
import {
  Box, Grid, Paper,
  Button, Divider, Typography
} from '@mui/material';
// import Grid from '@mui/material/Grid';
import dynamic from 'next/dynamic'
import LoadingItem from '../_common/Skeleton/stock';
import RecentNews from './RecentNews';
import Filings from './TickerTabs/Summary/Filings';
import TopIdea from './StockIdea/TopIdeas';
import Idea from './StockIdea';
import ChevronRightRoundedIcon from '@mui/icons-material/ChevronRightRounded';
import HighMultiCrushedEarnings from './HighMultiCrushedEarnings';

const StocksInNews = dynamic(() => import('./StocksInNews'),
  { loading: () => <LoadingItem height={300} /> })

const Item = styled(Paper)(({ theme }) => ({
  // backgroundColor: '#fff',
  // ...theme.typography.body2,
  // padding: theme.spacing(1),
  margin: 0,
  // textAlign: 'center',
  color: theme.palette.text.secondary,
  boxShadow: '0 !important',
  '& a': { color: '#174c86' }
}));

const NewStock = ({ tabData, stock_news, latestFilings, info, stock_ideas, highMultiCrushed, recentEarnings }) => {

  return (
    <>
      <Box component="div" className="home-wrapper">
        <Box component="div" className="row">
          <Box component="div" className="col-md-12 home-right" sx={{ mt: 1, mb: 17 }}>
            <Box component="div" className="row sum-r stock-in-news">
              <Grid container spacing={2}>
                {/* {stock_ideas && stock_ideas.length > 0 ?
                  <>
                    <Grid size={{ md: 12, sm: 12, xs: 12 }} sx={{}}>
                      <Box component="div" sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                        <Box component="div">
                          <Typography component="p" className="option-title"
                            sx={{
                              pr: 0.5,
                              mr: 'auto', fontWeight: '600 !important',
                              color: '#13113c  !important', mx: 1, mt: 2,
                              fontSize: '1rem  !important',
                            }} >
                            {`Featured Stock Ideas`}
                          </Typography>
                          <Typography variant="body2" component="div" color="rgba(0, 0, 0, 0.6)" sx={{ fontSize: '.75rem !important', textAlign: 'left', mx: 1, mb: 2 }} >{"Explore our featured stock ideas and investment opportunities to make informed decisions in today's market."}</Typography>
                        </Box>
                        <Box component="div">
                          <Button variant="text" size="small" endIcon={<ChevronRightRoundedIcon />}
                            sx={{ textTransform: 'none', borderRadius: '8px', boxShadow: 0, alignItems: 'center', lineHeight: 1, py: 1 }}
                            href="/stock-ideas"
                          >
                            View All
                          </Button>
                        </Box>
                      </Box>
                    </Grid>
                    <Grid size={{ md: 6, sm: 12, xs: 12 }}>
                      {stock_ideas?.slice(0, 1)?.map((post, index) => <TopIdea key={index} post={post} index={index} />)}
                    </Grid>
                    <Grid size={{ md: 6, sm: 12, xs: 12 }}>
                      {stock_ideas?.slice(1, 4)?.map((post, index) => <Idea key={index} post={post} index={index} spaceEvenly={stock_ideas?.length >= 3} />)}
                    </Grid>
                    <Grid size={{ md: 12, sm: 12, xs: 12 }} sx={{}}>
                      <Typography variant="body2" component="div" color="rgba(0, 0, 0, 0.6)" sx={{ fontSize: '.75rem !important', textAlign: 'left', mb: 2, fontStyle: 'italic' }} >
                        {"Disclaimer: Conduct thorough research and seek guidance from a certified financial advisor prior to finalizing any investment choices."}
                      </Typography>
                      <Divider sx={{ borderColor: '#eae9ee', mb: 1 }} />
                    </Grid>
                  </> : null} */}
                <Grid size={{ md: 12, sm: 12, xs: 12 }}  >
                  {/* <StocksInNews
                    tabs={tabData}
                    stock_news={stock_news}
                  /> */}
                  <Box component="div" className="s-card">
                    <Box component="div" className="option-content" sx={{ '& .MuiTableCell-root': { borderBottom: '1px solid #eae9ee', verticalAlign: "text-top" }, mt: 2 }}>
                      <Box component="div" className="k">
                        <Grid container spacing={2}>
                          <HighMultiCrushedEarnings
                            highMultiCrushed={highMultiCrushed}
                            recentEarnings={recentEarnings}
                          />
                          {/* <Grid size={{ md: 6, sm: 12, xs: 12 }} >
                            <Item elevation={0}>
                              <RecentNews
                                news={stock_news}
                                title="Recent Stock News"
                                description={"Latest updates on top performing stocks."}
                              />
                            </Item>
                          </Grid> */}
                        </Grid>
                      </Box>
                    </Box>
                  </Box>
                </Grid>
                {/* <Grid size={{ md: 4, sm: 12, xs: 12 }}  >
                  <Item sx={{ mb: 2, }} elevation={0}>
                    <Filings
                      info={info}
                      latestFilings={latestFilings}
                      tabData={tabData}
                      showTicker={true}
                      premiumOptions={false}
                      reportbg={"#e4eaf08a"}
                      description="Latest filings made by companies to Securities and Exchange Commission."
                      dataEventFrom={"homepage"}
                    />
                  </Item>
                  <Item elevation={0}>
                    <RecentNews
                      news={stock_news}
                      title="Recent Stock News"
                      description={"Latest updates on top performing stocks."}
                    />
                  </Item>
                </Grid> */}
              </Grid>
            </Box>
          </Box>
        </Box>
      </Box>
    </>
  );
};

export default React.memo(NewStock);
